<template>
	<v-app style="background-color:rgb(0,51,102);">
		<v-main style="display:flex;align-items:center;">
			<center>
				<img width="150" :src="baseLocation + '/resource/image/v-unite-logo.png'"/>
			</center>
		</v-main>
	</v-app>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			baseLocation: axios.defaults.baseURL
		};
	}
}
</script>